import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const istAllYearsReducer = (state = {
    MixedBarDiagrammIstAllYearsUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_MixDiagrammYearIst_istAllYearsReducer":
            return { ...state, MixedBarDiagrammIstAllYearsUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, MixedBarDiagrammIstAllYearsUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default istAllYearsReducer;
